module.exports = __webpack_public_path__ + "static/media/Picture1 person2.94a1f4ba.png";